import React from 'react';
import { Card, Button, Alert, Badge } from 'react-bootstrap';
import googleFormsService from '../services/googleFormsService';

const GoogleFormsIntegration = () => {
  const formUrl = googleFormsService.getAttendanceFormUrl();
  const configured = googleFormsService.isConfigured();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(formUrl).then(() => alert('Form URL copied!'));
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>Google Forms — Attendance Register</span>
        <Badge bg={configured ? 'success' : 'warning'}>
          {configured ? 'Configured' : 'Not Configured'}
        </Badge>
      </Card.Header>
      <Card.Body>
        {configured ? (
          <>
            <p className="text-muted mb-2">
              This is the Google Form sent to learners for attendance register signing.
            </p>
            <div className="d-flex align-items-center gap-2 mb-3">
              <code className="flex-grow-1 bg-light p-2 rounded text-break">{formUrl}</code>
            </div>
            <div className="d-flex gap-2">
              <Button
                variant="primary"
                href={formUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Form
              </Button>
              <Button variant="outline-secondary" onClick={copyToClipboard}>
                Copy URL
              </Button>
            </div>
          </>
        ) : (
          <Alert variant="warning">
            <strong>Setup required:</strong> Set <code>REACT_APP_GOOGLE_FORMS_ATTENDANCE_URL</code> in
            your <code>.env.local</code> file to the share URL of your Google Form attendance register.
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
};

export default GoogleFormsIntegration;
